/**
 * Sawyer 05 end-of-day-tenders (C4) — the optional check number the desk
 * types when it takes a check at checkout (one visit or the whole household).
 * Sawyer: "a good handful of clients … want to write a check." The number is
 * what makes a deposit, or a later QuickBooks entry, traceable to the visit.
 *
 * Optional by design: blank is valid and never blocks "Record as paid". The
 * server trims it and refuses anything but letters, digits, spaces and
 * dashes, up to 30 characters (payments-admin checkNumberSchema); the input
 * caps the length so the desk cannot type past it.
 */
export const CHECK_NUMBER_MAX_LENGTH = 30;

export interface CheckNumberFieldProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly disabled?: boolean;
}

export function CheckNumberField({ value, onChange, disabled = false }: CheckNumberFieldProps): JSX.Element {
  return (
    <label className="ferro-field ferro-settle-now__check-number" htmlFor="settle-now-check-number">
      <span className="ferro-field__label">Check number (optional)</span>
      <input
        id="settle-now-check-number"
        className="ferro-field__input"
        type="text"
        inputMode="numeric"
        autoComplete="off"
        maxLength={CHECK_NUMBER_MAX_LENGTH}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        data-testid="settle-now-check-number"
      />
    </label>
  );
}
